module.exports = __webpack_public_path__ + "static/media/minus.44259ec5.png";